<template>
	<div class="pem-sidebar margin-bottom-xs-2 margin-bottom-md-0">
		<div class="beta-banner">BETA</div>
		<LoginBox v-if="sidebar == 'login'" />
		<ForgotPasswordBox v-if="sidebar == 'forgot-password'" />
		<ResetPasswordBox v-if="sidebar == 'reset-password'" />
		<SignupBox v-if="sidebar == 'signup'" />
		<transition name="fade">
			<LoggedInSidebar v-if="sidebar == 'logged-in'" />
		</transition>
	</div>
</template>
<script>
import LoginBox from "./LoginBox.vue";
import LoggedInSidebar from "./LoggedInSidebar.vue";
import SignupBox from "./SignupBox.vue";
import ForgotPasswordBox from "./ForgotPasswordBox.vue";
import ResetPasswordBox from "./ResetPasswordBox.vue";
export default {
	name: "LeftSidebar",
	props: [],
	components: {
		LoginBox,
		LoggedInSidebar,
		SignupBox,
		ForgotPasswordBox,
		ResetPasswordBox
	},
	computed: {
		user() {
			return this.$store.state.user;
		},
		sidebar() {
			return this.$store.state.sidebar;
		}
	},
	methods: {},
	mounted() {}
};
</script>